import React, {useState} from 'react';
import {BaseInputProps} from '../..';

import {Container, Label, Input as StyledInput} from './styles';
import {useController, useFormContext} from 'react-hook-form';
import {NestedKeys} from 'shared/types/key-manipulation';

export type TimePickerProps<T = any> = BaseInputProps & {
  name: NestedKeys<T>;
  gridColumn?: number;
};

const TimePicker: React.FC<TimePickerProps> = ({
  name,
  label,
  gridColumn,
  border,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  hidden,
  required,
  ...props
}) => {
  const {control} = useFormContext();
  const {field} = useController({control, name});
  const [focused, setFocused] = useState(false);

  return (
    <Container {...{gridColumn, border, focused}}>
      <Label>{label}</Label>
      <StyledInput
        {...{...props, ...field, value: field.value ?? ''}}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        type="time"
      />
    </Container>
  );
};

export default TimePicker;
